// Function to delete IndexedDB
// Simplified the function to directly request database deletion, preventing race conditions where the DB was opened before deletion.
function deleteDatabase(dbName: string): void {
  const deleteRequest = indexedDB.deleteDatabase(dbName);

  deleteRequest.onsuccess = () => {
    console.log(`Database ${dbName} deleted successfully`);
  };

  deleteRequest.onerror = (event) => {
    console.error(`Error deleting database ${dbName}:`, (event.target as IDBOpenDBRequest).error);
  };

  deleteRequest.onblocked = () => {
    console.warn(`Database ${dbName} deletion blocked. Please close other tabs/windows with this application open.`);
  };
}

export default deleteDatabase;
